// A logging stub, intended to be swapped for a proper logging
// framework at the appropriate point in the future.

import { environment } from '../../environments/environment';

function logMessage(logContext, loggingFunction, messageType, messageItems) {

    if (loggingFunction === null) {
      console.log('should not get here')
      loggingFunction = console.log;
    }
    // if (environment.disableLogger) {
    //     return;
    // }

    // not all browsers have console available all the time.
    // see:
    // https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function
    // https://stackoverflow.com/questions/22315167/in-ie11-how-to-use-console-log
    // http://kevinquillen.com/ie/2014/06/11/ie-console-woes

    // if (!console) {
    //     return;
    // }
    loggingFunction = loggingFunction || console.log;
    if (!loggingFunction) {
        return;
    }

    // business as usual...
    messageItems = messageItems || [];

    const args = [].slice.call(messageItems);
    args.unshift(logContext.name + ':');
    args.unshift(`[${messageType}]`);

    // TODO: temp fix for Safari 9 throwing exception when calling apply() on console.log
    try {
        loggingFunction.apply(null, args);
    } catch (e) {}
}

export class Log {

    readonly name: string;

    static getLogger(name: string) {
        return new Log(name);
    }

    constructor(name: string) {
        this.name = name;
    }

    info(...params: Object[]) {
        logMessage(this, console.log, 'INFO', params);
    }

    warn(...params: Object[]) {
        logMessage(this, console.warn, 'WARN', params);
    }

    debug(...params: Object[]) {
        logMessage(this, console.log, 'DEBUG', params);
    }

    verbose(...params: Object[]) {
        logMessage(this, console.log, 'VERBOSE', params);
    }

    trace(...params: Object[]) {
        logMessage(this, console.log, 'TRACE', params);
    }

    error(...params: Object[]) {
        logMessage(this, console.error, 'ERR', params);
    }
}



// WEBPACK FOOTER //
// ./app/shared/log.ts